/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'activity': {
    width: 19,
    height: 15,
    viewBox: '0 0 19 15',
    data: '<path pid="0" d="M7.874 13.435v-1.622H1.775c-.555 0-1.005-.45-1.005-1.006V1.27C.77.715 1.22.265 1.775.265h15.906c.555 0 1.005.45 1.005 1.005v9.537c0 .555-.45 1.006-1.005 1.006h-6.1v1.622h3.264v1H4.611v-1h3.263zm.17-9.663l3.025 6.288 1.605-3.3h3.897v-.9h-4.46L11.073 7.99 8.05 1.704 5.94 6.037H3.778v.9h2.724l1.542-3.165z" _fill="#BCBCBC" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/activity.js